export enum NotificationStrategy {
  STANDARD = 'STANDARD',
  NOTIFY_ALL = 'NOTIFY_ALL',
  NOTIFY_POLE_FIRST = 'NOTIFY_POLE_FIRST',
}
